import { render, staticRenderFns } from "./PanelWithPurchaseOrderRevise.vue?vue&type=template&id=32ad5d38&lang=pug&"
import script from "./PanelWithPurchaseOrderRevise.vue?vue&type=script&lang=ts&"
export * from "./PanelWithPurchaseOrderRevise.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithPurchaseOrderRevise.vue?vue&type=style&index=0&id=32ad5d38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports